import API from 'types/api';

const initialState = {};

export default (state = initialState, { type, payload, request }) => {
  switch (type) {
    case API.GET_EPISODES_ERROR:
      return { ...state, [payload.id]: { ...state[payload.id], isLoading: false, isError: true } };
    case API.GET_EPISODES_FETCH:
      return { ...state, [payload.id]: { ...state[payload.id], isLoading: true, isError: false } };
    case API.GET_EPISODES_SUCCESS:
      return {
        ...state,
        [request.id]: {
          ...state[request.id],
          episode_list: payload.result,
          isLoading: false,
          isError: false,
        },
      };
    default:
      if (payload && payload.entities && payload.entities.season) {
        return { ...state, ...payload.entities.season };
      }
      return state;
  }
};
